<template>
<div class="select">
  <span>{{ options[value] || value }}</span>
  <select :value="value" v-on:input="$emit('input', $event.target.value)">
    <option v-for="(optlabel, optval) in options" :value="optval">{{ optlabel }}</option>
  </select>
</div>
</template>

<script>
export default {
  props: ["value", "options"],
  
}
</script>
